import { ERC20Spec, Bytes32ERC20Spec } from 'optionality';
import contract from './contract';

export default (context) => {
  const ERC20Contract = contract(ERC20Spec)(context);
  const Bytes32ERC20Contract = contract(Bytes32ERC20Spec)(context);
  return {
    at: async (address) => {
      const parent = await ERC20Contract.at(address);
      const alt = await Bytes32ERC20Contract.at(address);

      const convert = (promise) => {
        return promise.then(hex => Buffer(hex.substring('2').replace(/(00)+$/g, ''), 'hex').toString('utf8'));
      }

      const result = Object.create(parent);
      result.name = function() {
        return parent.name()
          .catch(() => convert(alt.name()));
      };
      result.symbol = function() {
        return parent.symbol()
          .catch(() => convert(alt.symbol()));
      };
      return result;
    }
  };
};


// WEBPACK FOOTER //
// ./src/api/erc20-contract.js